"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "usePortal_unstable", {
    enumerable: true,
    get: function() {
        return usePortal_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _reactutilities = require("@fluentui/react-utilities");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _toMountNodeProps = require("../../utils/toMountNodeProps");
const _usePortalMountNode = require("./usePortalMountNode");
const usePortal_unstable = (props)=>{
    const { element, className } = (0, _toMountNodeProps.toMountNodeProps)(props.mountNode);
    const virtualParentRootRef = _react.useRef(null);
    const fallbackElement = (0, _usePortalMountNode.usePortalMountNode)({
        disabled: !!element,
        className
    });
    const state = {
        children: props.children,
        mountNode: element !== null && element !== void 0 ? element : fallbackElement,
        virtualParentRootRef
    };
    _react.useEffect(()=>{
        if (state.virtualParentRootRef.current && state.mountNode) {
            (0, _reactutilities.setVirtualParent)(state.mountNode, state.virtualParentRootRef.current);
        }
        return ()=>{
            if (state.mountNode) {
                (0, _reactutilities.setVirtualParent)(state.mountNode, undefined);
            }
        };
    }, [
        state.virtualParentRootRef,
        state.mountNode
    ]);
    return state;
};
